import SEO from "../../components/shared/SEO";
import { Link, useNavigate } from 'react-router-dom';

export default function TermsOfService() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050505] text-gray-400 font-sans p-6 md:p-20 relative overflow-hidden">
      <SEO title="Terms of Service" description="Usage framework, responsibilities, and service agreements." />
      
      <div className="max-w-4xl mx-auto">
        <button onClick={() => navigate(-1)} className="text-[10px] font-black uppercase tracking-[0.3em] text-orange-500 mb-8 block transition-opacity hover:opacity-80">← Back</button>
        <h1 className="text-4xl md:text-7xl font-black text-white mb-4 tracking-tighter uppercase leading-none">Terms of <span className="text-orange-500">Service</span></h1>
        <p className="text-[10px] font-mono text-gray-600 uppercase tracking-[0.2em] mb-8">Last Updated: February 20, 2026</p>

        <p className="text-lg text-gray-300 font-medium leading-relaxed mb-12 max-w-2xl">
          Welcome to EnvDock. By using my service, you agree to these terms.
        </p>
        
        <div className="bg-white/[0.02] border border-white/5 rounded-[3rem] p-8 md:p-16 space-y-16">
          
          <div className="space-y-4">
            <h3 className="text-xs font-black text-white uppercase tracking-[0.3em]">01. Service Description</h3>
            <p className="text-sm md:text-base text-gray-500 leading-relaxed font-medium">
                EnvDock is a SaaS tool that provides secure environment variable and secret distribution for your applications and development teams.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-xs font-black text-white uppercase tracking-[0.3em]">02. Account Responsibility</h3>
            <p className="text-sm md:text-base text-gray-500 leading-relaxed font-medium">
                You are responsible for maintaining the security of your account and password. I cannot be held liable for any loss or damage from your failure to comply with this security obligation.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-xs font-black text-white uppercase tracking-[0.3em]">03. Payments & Refunds</h3>
            <p className="text-sm md:text-base text-gray-500 leading-relaxed font-medium">
                All payments are processed securely through Lemon Squeezy, our Merchant of Record. Please refer to our <Link to="/refund-policy" className="text-white hover:text-orange-500 underline decoration-white/20 hover:decoration-orange-500/50 underline-offset-4 transition-all">Refund Policy</Link> for details on money-back guarantees.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-xs font-black text-white uppercase tracking-[0.3em]">04. Prohibited Use</h3>
            <p className="text-sm md:text-base text-gray-500 leading-relaxed font-medium">
                You may not use this service for any illegal activities or to violate any laws in your jurisdiction.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-xs font-black text-white uppercase tracking-[0.3em]">05. Limitation of Liability</h3>
            <p className="text-sm md:text-base text-gray-500 leading-relaxed font-medium">
                The service is provided "as is." In no event shall I (the developer) be liable for any damages arising out of the use or inability to use the service.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-xs font-black text-white uppercase tracking-[0.3em]">06. Changes to Terms</h3>
            <p className="text-sm md:text-base text-gray-500 leading-relaxed font-medium">
                I reserve the right to update these terms at any time. Continued use of the app constitutes acceptance of any new terms.
            </p>
          </div>

          <div className="p-8 bg-black/40 border border-white/5 rounded-3xl font-mono text-[11px] uppercase tracking-tighter text-gray-500 leading-relaxed">
             [CONTACT PROTOCOL] For any questions regarding these terms, please transmit a secure message to <a href="mailto:envdock@gmail.com" className="text-white hover:text-orange-500 transition-colors">envdock@gmail.com</a>.
          </div>
          
        </div>
      </div>
    </div>
  );
}